<template>
    <div class="detail-page">
        <Header></Header>

        <div class="detail-container">
            <div class="detail-inner">
                <div class="detail-meta">
                    <router-link to="/blogs" class="back-link">
                        <i class="el-icon-arrow-left"></i> 返回列表
                    </router-link>
                </div>

                <article class="detail-content">
                    <h1 class="detail-title">{{ blog.title }}</h1>

                    <div class="detail-actions" v-if="ownBlog">
                        <router-link
                            :to="{name: 'BlogEdit', params: {blogId: blog.id}}"
                            class="edit-link"
                        >
                            <i class="el-icon-edit"></i> 编辑
                        </router-link>
                    </div>

                    <el-divider></el-divider>

                    <div class="markdown-body" v-html="blog.content"></div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
    import 'github-markdown-css'
    import Header from "../components/Header";
    export default {
        name: "BlogDetail.vue",
        components: {Header},
        data() {
            return {
                blog: {
                    id: "",
                    title: "",
                    content: ""
                },
                ownBlog: false
            }
        },
        created() {
            const blogId = this.$route.params.blogId
            console.log(blogId)
            const _this = this
            this.$axios.get('/blog/' + blogId).then(res => {
                const blog = res.data.data
                _this.blog.id = blog.id
                _this.blog.title = blog.title
                var MardownIt = require("markdown-it")
                var md = new MardownIt()
                var result = md.render(blog.content)
                _this.blog.content = result
                _this.ownBlog = (blog.userId === _this.$store.getters.getUser.id)
            })
        }
    }
</script>

<style scoped>
    .detail-page {
        min-height: 100vh;
        background: #f5f5fb;
    }

    .detail-container {
        max-width: 800px;
        margin: 0 auto;
        padding: 32px 20px 60px;
    }

    .detail-meta {
        margin-bottom: 20px;
    }

    .back-link {
        font-size: 14px;
        color: #999;
        text-decoration: none;
        transition: color 0.2s;
    }

    .back-link:hover {
        color: #58a8e0;
    }

    .detail-content {
        background: #fff;
        border-radius: 12px;
        padding: 40px 36px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    }

    .detail-title {
        font-size: 28px;
        font-weight: 700;
        color: #1a1a1a;
        margin: 0 0 12px;
        line-height: 1.4;
    }

    .detail-actions {
        margin-bottom: 8px;
    }

    .edit-link {
        font-size: 14px;
        color: #58a8e0;
        text-decoration: none;
    }

    .edit-link:hover {
        text-decoration: underline;
    }

    .detail-content >>> .el-divider {
        margin: 20px 0 28px;
    }

    .detail-content >>> .markdown-body {
        font-size: 15px;
        line-height: 1.8;
        color: #333;
    }

    .detail-content >>> .markdown-body h1,
    .detail-content >>> .markdown-body h2,
    .detail-content >>> .markdown-body h3 {
        margin-top: 24px;
        margin-bottom: 12px;
        color: #1a1a1a;
    }

    .detail-content >>> .markdown-body pre {
        border-radius: 8px;
    }

    .detail-content >>> .markdown-body img {
        border-radius: 8px;
    }
</style>
